import {newcharge,systemFetch} from "@/utils/fetch";
 //发送验证码
 export function queryVerificationCode(smsCodeKey) {
    return newcharge({
        url: 'orderpay/chargeSetting/queryVerificationCode?smsCodeKey='+smsCodeKey,
        method: 'get'
    });
  }

//新增平台商户
export function addAbcagent(args,smsCode) {
    return newcharge({
        headers: {
            'content-type': 'application/json'
        },
        url: 'orderpay/chargeSetting/addAbcagent?smsCode='+smsCode,
        method: 'POST',
        data: JSON.stringify(args)
    });
  }
//支付下发记录列表
export function queryAbcagentList(args){
    const params=new URLSearchParams();
    params.append("pageNo",args.pageNo);
    params.append("pageSize",args.pageSize);
    return newcharge({
      url:'orderpay/chargeSetting/queryAbcagentList',
      method:'get',
      params
    })
  }

//删除平台商户
export function deleteAbcagent(id){
    const params=new URLSearchParams();
    params.append("id",id);
    return newcharge({
      url:'orderpay/chargeSetting/deleteAbcagent',
      method:'get',
      params
    })
  }
  export function querySchoolListByName(name) {
    let params = new URLSearchParams();
    params.append("name",name);
    return systemFetch({
        url: 'api/school/querySchoolListByName',
        method: 'get',
        params
    });
}

//清分记录列表
export function queryWithdBatchList(args){
    const params=new URLSearchParams();
    params.append("pageNo",args.pageNo);
    params.append("pageSize",args.pageSize);
    params.append("merId",args.merId);
    params.append("schoolName",args.schoolName);
    params.append("subMerId",args.subMerId);
    params.append("withdDateEnd",args.withdDateEnd);
    params.append("withdDateStart",args.withdDateStart);
    return newcharge({
      url:'orderpay/withd/queryWithdBatchList',
      method:'get',
      params
    })
  }

  export function querySubmerhPurseByMerId(merId) {
    let params = new URLSearchParams();
    params.append("merId",merId);
    return newcharge({
        url: 'orderpay/withd/querySubmerhPurseByMerId',
        method: 'get',
        params
    });
}
export function downloadReceipt(withdBatchSn) {
  let params = new URLSearchParams();
  params.append("withdBatchSn",withdBatchSn);
  return newcharge({
      url: 'orderpay/withd/downloadReceipt',
      method: 'get',
      params
  });
}
export function queryWithdProgress(withdBatchSn) {
  let params = new URLSearchParams();
  params.append("withdBatchSn",withdBatchSn);
  return newcharge({
      url: 'orderpay/withd/queryWithdProgress',
      method: 'get',
      params
  });
}
export function updateWithdRetry(withdBatchSn) {
  let params = new URLSearchParams();
  params.append("withdBatchSn",withdBatchSn);
  return newcharge({
      url: 'orderpay/withd/updateWithdRetry',
      method: 'get',
      params
  });
}
export function queryMerhPurseByMerhId(merId) {
  let params = new URLSearchParams();
  params.append("merId",merId);
  return newcharge({
      url: 'orderpay/merhPurse/queryMerhPurseByMerhId',
      method: 'get',
      params
  });
}

//查询二级商户(wyms)
export function querySubmerhListByMerId(args){
  const params=new URLSearchParams();
  params.append("pageNo",args.pageNo);
  params.append("pageSize",args.pageSize);
  params.append("merId",args.merId);
  params.append("schoolId",args.schoolId?args.schoolId:"");
  params.append("searchVal",args.searchVal);
  return newcharge({
    url:'orderpay/merhPurse/querySubmerhListByMerId',
    method:'get',
    params
  })
}

//收支明细(wyms)
export function querySubmerhDetailListByMerId(args){
  const params=new URLSearchParams();
  params.append("pageNo",args.pageNo);
  params.append("pageSize",args.pageSize);
  params.append("balmodTimeEnd",args.balmodTimeEnd);
  params.append("balmodTimeStart",args.balmodTimeStart);
  params.append("subMerId",args.subMerId);
  params.append("revenue",args.revenue?(args.revenue==1?true:false):"");
  params.append("schoolId",args.schoolId);
  return newcharge({
    url:'orderpay/merhPurse/querySubmerhDetailListByMerId',
    method:'get',
    params
  })
}

//2.21按天对账
export function querySummaryList(args){
  const params=new URLSearchParams();
  params.append("billdateformat",args.billdateformat);
  params.append("merId",args.merId);
  return newcharge({
    url:'orderpay/withd/querySummaryList',
    method:'get',
    params
  })
}

//2.22发起对账
export function updateBilltransfer(args){
  const params=new URLSearchParams();
  params.append("billdateformat",args.billdateformat);
  params.append("merId",args.merId);
  return newcharge({
    url:'orderpay/withd/updateBilltransfer',
    method:'get',
    params
  })
}
//2.22发起对账
export function queryDetailList(args){
  const params=new URLSearchParams();
  params.append("billdateformat",args.billdateformat);
  params.append("merId",args.merId);
  params.append("pageNo",args.pageNo);
  params.append("pageSize",args.pageSize);
  return newcharge({
    url:'orderpay/withd/queryDetailList',
    method:'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/platformmerchant.js